import theme from './ListTable.module.scss';
import cellActionsTheme from '../CellActions/RowTableCellActions.module.scss';

export default [
	theme.row,
	cellActionsTheme.row,
];
